"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubtle = exports.getRandomValue = exports.getCrypto = exports["default"] = void 0;
var subtle;
var getCrypto = function getCrypto() {
  var _window, _window2;
  return ((_window = window) === null || _window === void 0 ? void 0 : _window.crypto) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.msCrypto);
};
exports.getCrypto = getCrypto;
var getRandomValue = function getRandomValue() {
  return getCrypto().getRandomValues(new Uint32Array(1))[0] / (Math.pow(2, 32) - 1);
};
exports.getRandomValue = getRandomValue;
var getSubtle = function getSubtle() {
  if (subtle) {
    return subtle;
  } else {
    var crypto = getCrypto();
    subtle = (crypto === null || crypto === void 0 ? void 0 : crypto.subtle) || (crypto === null || crypto === void 0 ? void 0 : crypto.webkitSubtle);
    return subtle;
  }
};
exports.getSubtle = getSubtle;
var _default = getSubtle;
exports["default"] = _default;